export default "__VITE_ASSET__DlmkY1ig__"